module.exports = __webpack_public_path__ + "img/flowLogo.536e3688.png";